import { useState, useEffect, ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { authSession } from "../utils/authService";

const PublicRoute: React.FC<{ children: ReactElement }> = ({ children }) => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  useEffect(() => {
    const fetchAccessToken = async () => {
      const token = await authSession();
      setAccessToken(token ?? null);
    };

    fetchAccessToken();
  }, []);
  if (accessToken) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PublicRoute;
